<template>
  <ion-page class="vocabulary-test">
    <page-white-background
      v-if="!contentVisible"
      title="词汇量测试"
      router-type="modal"
      :external-source="externalSource"
      @router-back="routerBack"
    >
      <template #default>
        <div class="vocabulary-test_content">
          <span class="vocabulary-test_title weight-700">词汇量测试</span><br />
          <span class="content-explain weight-500 mt-3 mb-8"
            >花几分钟测试一下，定位你的词汇量水平</span
          >
          <div class="content-logo">
            <img :src="getBrandImageUrl('personal/vocabulary_test_logo.png')" alt="" />
          </div>
          <ion-button class="light_green_bg content-button" shape="round" @click="onStart"
            >开始测试
          </ion-button>
          <span class="button-explain">诚实做题可以得到真实的测试结果</span>
        </div>
      </template>
    </page-white-background>
    <VocabularyTestModal
      v-if="contentVisible"
      :correct="correct"
      :current-word="currentWord"
      :remaining="remaining"
      :wrong="wrong"
      :countdown-time="countdownTime"
      :on-select="onSelect"
      @onFinish="onFinish"
    />
  </ion-page>
</template>

<script>
import { IonButton, IonPage, modalController } from "@ionic/vue"

import { checkmarkCircle, closeOutline, cut, play } from "ionicons/icons"
import PageWhiteBackground from "@/components/PageWhiteBackground.vue"

import VocabularyTestResult from "@/views/personal/VocabularyTestResult"
import VocabularyTestModal from "@/views/personal/VocabularyTestModal.vue"

import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import { useDebounceFn } from "@vueuse/core"
import PageDialog from "@/components/PageDialog.vue"

export default {
  name: "VocabularyTest",
  components: {
    VocabularyTestModal,
    PageWhiteBackground,
    IonPage,
    IonButton,
  },
  props: ["testId", "testUserId"],

  setup() {
    return {
      cut,
      play,
      checkmarkCircle,
      closeOutline,
    }
  },

  data() {
    return {
      remainingTime: 11000, //10秒
      countdownTime: 10, //倒计时10s
      remainingTimer: undefined,
      countdownTimer: undefined,
      delayTime: 1000, //选择答案之后延时1秒显示下一个单词
      delayTimer: undefined,

      dataList: [],
      currentWord: {},
      currentIndex: 0,
      correct: 0, //正确的数量
      wrong: 0, //错误的数量
      remaining: 0,
      contentVisible: false,
      remark: "全测", //结束条件
      isOver: false, //测试是否结束
      timeLock: false, //选完答案以后等待3秒
      brandImages: BRAND_IMAGES,
      currentTestId: "",
      externalSource: false,
    }
  },
  created() {
    if (this.$route.query && this.$route.query.source) {
      this.externalSource = this.$route.query.source === "external"
    }
  },
  mounted() {
    this.userinfo = this.store.getUser()
    this.getTestId()
    this.queryTestWords()
    this.clearTimer()
  },

  methods: {
    getTestId() {
      if (!this.testId) {
        this.ajax
          .get("/vocabulary/createVocabularyTest?userId=" + this.userinfo.userId)
          .then(async (res) => {
            if (res.data.success) {
              this.currentTestId = res.data.data.testId
            }
          })
      } else {
        this.currentTestId = this.testId
      }
    },
    getBrandImageUrl,
    async openVocabularyTestResult() {
      clearTimeout(this.remainingTimer)
      clearInterval(this.countdownTimer)
      const modal = await modalController.create({
        component: VocabularyTestResult,
        componentProps: { testId: this.currentTestId },
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    clearFocus() {
      document.querySelectorAll(".focus").forEach(function (node) {
        node.classList.remove("focus")
      })
    },

    routerBack() {
      modalController.dismiss()
    },

    onFinish() {
      this.clearTimer()
      modalController.dismiss()
    },

    clearTimer() {
      clearTimeout(this.remainingTimer)
      clearInterval(this.countdownTimer)
      clearTimeout(this.delayTimer)
    },

    doPlay() {
      this.playSound(this.currentWord.word)
    },
    async StartTip() {
      const modal = await modalController.create({
        component: PageDialog,
        id: "PageDialog",
        componentProps: {
          message: "为确保结果准确，建议测试两次哦",
        },
        cssClass: "center_modal_controller_class3",
        backdropDismiss: false,
      })

      await modal.present()
      return modal.onDidDismiss()
    },
    async onStart() {
      await this.StartTip()
      const that = this
      this.contentVisible = true
      this.doPlay()
      const time = this.remainingTime - 2
      clearTimeout(this.remainingTimer)
      clearInterval(this.countdownTimer)
      this.remainingTimer = setTimeout(function () {
        that.timeLock = false
        that.onSelect(7)
        clearInterval(this.countdownTimer)
      }, time)
      this.countdownTimer = setInterval(() => {
        this.countdownTime--
      }, 1000)
    },

    //查询需要练习的词汇
    queryTestWords() {
      this.ajax.get("/vocabulary/queryTestWords").then((res) => {
        if (res.data.list && res.data.list.length > 0) {
          this.dataList = res.data.list
          this.remaining = this.dataList.length
          this.currentWord = this.dataList[this.currentIndex]
        }
      })
    },

    //测试结束，保存结果
    saveTestResult() {
      const that = this
      const resultList = []
      this.dataList.forEach(function (item) {
        if (item.myAnswer) {
          resultList.push(item)
        }
      })

      this.ajax
        .post("/vocabulary/saveTestResult", {
          testId: this.currentTestId,
          userId: this.testUserId,
          correct: this.correct,
          wrong: this.wrong,
          remark: this.remark,
          details: resultList,
        })
        .then(async (res) => {
          if (res.data.success) {
            if (!this.$route.path.includes("vocabulary-test")) {
              await modalController.dismiss()
            }
            await that.openVocabularyTestResult()
          }
        })
    },

    //点击单词,显示释义
    onSelect(option, ev) {
      const that = this

      //如果时间未到则不响应用户操作
      if (that.timeLock) {
        return
      }

      clearTimeout(that.remainingTimer)
      clearTimeout(that.countdownTimer)
      clearTimeout(that.delayTimer)

      if (ev) {
        that.clearFocus()
        ev.target.classList.add("focus")
      }

      this.currentWord.myAnswer = option
      this.currentWord.showAnswer = true
      this.dataList[this.currentIndex].myAnswer = option

      this.correct = 0
      this.wrong = 0
      let consecutive = 0 //连续错误的数量
      this.remaining = 0
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].myAnswer) {
          if (this.dataList[i].answer == this.dataList[i].myAnswer) {
            this.correct++
            consecutive = 0
          } else {
            this.wrong++
            consecutive++
          }
        } else {
          this.remaining++
        }
      }

      //连续错误3次
      if (consecutive >= 5) {
        this.remark = "连续错误5次"
        this.isOver = true
        this.alert("测试结束。", useDebounceFn(this.saveTestResult, 500))
      }

      //累计错误5次
      else if (this.wrong >= 7) {
        this.remark = "累计错误7次"
        this.isOver = true
        this.alert("测试结束。", useDebounceFn(this.saveTestResult, 500))
      }

      // 其它情况
      else {
        // 测完最后一个单词
        if (this.currentIndex == this.dataList.length - 1) {
          this.remark = "全部测完"
          this.isOver = true
          this.alert("测试结束。", useDebounceFn(this.saveTestResult, 500))
        }

        //回答正确，显示下一个单词
        else if (this.currentIndex < this.dataList.length - 1) {
          that.timeLock = true

          that.delayTimer = setTimeout(function () {
            that.currentWord = that.dataList[++that.currentIndex]
            that.doPlay()
            that.timeLock = false
            that.clearFocus()
            that.countdownTime = 10
            that.countdownTimer = setInterval(() => {
              that.countdownTime -= 1
            }, 1000)
          }, that.delayTime)
          this.remainingTimer = setTimeout(function () {
            that.onSelect(7)
            clearInterval(this.countdownTimer)
          }, that.remainingTime)
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.vocabulary-test {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &_content {
    width: 100%;
    height: 80%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .content-explain {
      display: inline-block;
      color: var(--font-deep-gray);
    }

    .content-logo {
      width: 58%;
      margin: 0 auto;
    }

    .content-button {
      width: 75%;
      margin: 8vw auto 6vw;

      &::part(native) {
        padding: 4.5vw 2vw;
      }
    }

    .button-explain {
      display: inline-block;
      color: var(--font-gray);
    }
  }

  &_title {
    color: var(--font-black-color);
    font-size: var(--font-5-point-5);
  }
}
</style>
